import http from "./httpService";

const apiEndpoint = `/img`;

function getUrl(pathParam) {
  return `${apiEndpoint}/${pathParam}/`;
}

function uploadImage(req) {
  return http.post(apiEndpoint, req);
}

function updateImage(req) {
  return http.put(apiEndpoint, req);
}

function getImage(path) {
  return http.get(`/${path}`, {
    responseType: "blob"
  });
}
function getProofDoc(path) {
  return http.get(getUrl(`s3_proof_doc/${path}`), {
    responseType: "blob"
  });
}
function getS3Image(sealNum){
  return http.get(getUrl(`s3_img/${sealNum}`), {
    responseType: "blob"
  });
}

export default {
  getImage,
  updateImage,
  uploadImage,
  getS3Image,
  getProofDoc
};
